import lodashGet from 'lodash/get';
import { removeLink } from '../..';
/**
 * Removes non-pseudo correlations which signal id can not be found or have no links anymore.
 *
 * @param {Values} values
 * @param {Experiment1DSignals} signals1D
 * @param {Experiment2DSignals} signals2D
 */
export function removeObsoleteLinksAndNotLinkedCorrelations(correlations, signals1D, signals2D) {
    const _correlations = correlations.filter((correlation) => !correlation.pseudo);
    const removeList = _correlations.slice();
    _correlations.forEach((correlation) => {
        for (const link of correlation.link) {
            if (link.experimentType === '1d') {
                // search in 1D data
                if (lodashGet(signals1D, link.atomType[0], []).some((signal1D) => signal1D.signal.id === link.signal.id)) {
                    const index = removeList.indexOf(correlation);
                    if (index >= 0) {
                        removeList.splice(index, 1);
                    }
                }
                else if (!link.pseudo) {
                    // remove obsolete link to not anymore existing signal
                    removeLink(correlation, link.id);
                }
            }
            else if (lodashGet(signals2D, `${link.experimentType}`, []).some((signal2D) => signal2D.signal.id === link.signal.id)) {
                // search in 2D data
                const index = removeList.indexOf(correlation);
                if (index >= 0) {
                    removeList.splice(index, 1);
                }
            }
            else if (!link.pseudo) {
                // remove obsolete link to not anymore existing signal
                removeLink(correlation, link.id);
            }
        }
    });
    removeList.forEach((correlation) => {
        const index = correlations.indexOf(correlation); // in case we already removed previously
        if (index >= 0) {
            correlations.splice(index, 1);
        }
    });
    return correlations;
}
//# sourceMappingURL=removeObsoleteLinksAndNotLinkedCorrelations.js.map